export const mobileCompanyNavigation = [
  {
    href: "https://geonix.com/isp/",
    text: "ispProxy"
  },
  {
    href: "https://geonix.com/resident/",
    text: "resedentialProxy"
  },
  {
    href: "https://geonix.com/",
    text: "personalProxy"
  },
  {
    href: "https://geonix.com/ipv6/",
    text: "proxyIpv6"
  },
  {
    href: "https://geonix.com/company/articles/",
    text: "articles"
  },
  {
    href: "https://geonix.com/contacts/",
    text: "contacts"
  }
];
